document.addEventListener('alpine:init', () => {
  Alpine.data(
    'Filterable',
    ({
      firstLevelTags = [],
      secondLevelTags = [],
      thirdLevelTags = [],
      currentTags = [],
      supportFirstLevels = [],
      activeTags = [],
      tagTexts = {},
    }) => ({
      filtersOpen: false,
      sortOpen: false,
      filtersCache: [],
      price_range: null,
      loading: false,
      focusedBeforeUpdate: null,
      searchParams: null,
      countHTML: null,
      filtersFormHTML: null,
      sortersFormHtml: null,
      resultsHTML: null,
      drawerToggleHTML: null,
      afterUpdateCallback: null,
      firstLevelTags,
      secondLevelTags,
      thirdLevelTags,
      currentTags,
      supportFirstLevels,
      activeTags,
      tagHasChildL: {},
      tagSuggestions: [],
      activeCategoryTags: [],
      activeSuggestTag: null,
      tagTexts,
      isMdBreakpoint: window.isMdBreakpoint(),
      mdBreakpointMQL: window.mdBreakpointMQL(),
      handleTagOpen: function handleOpen(tag) {
        if (this.activeTags.includes(tag)) {
          this.activeTags.splice(this.activeTags.indexOf(tag), 1);
        } else {
          this.activeTags.push(tag);
        }
      },
      clickOutside(event, property, sidebarOnDesktop) {
        if (!(sidebarOnDesktop && this.isMdBreakpoint)) {
          event.preventDefault();
        }

        if (
          event.target &&
          (event.target === this.$refs.filterDropDownToggle || event.target === this.$refs.sortDropDownToggle)
        )
          return;

        this[property] = false;
      },
      focusOut(event, property) {
        if (event.relatedTarget) {
          if (
            event.relatedTarget === this.$refs.filterDropDownToggle ||
            event.relatedTarget === this.$refs.sortDropDownToggle
          )
            return;

          const dropdownParent = event.relatedTarget.closest('[data-filterable-dropdown]');

          if (!dropdownParent) {
            this[property] = false;
          }
        }
      },
      onEscape() {
        if (this.filtersOpen) {
          this.filtersOpen = false;
          this.$refs.filterDropDownToggle.focus();
        }
        if (this.sortOpen) {
          this.sortOpen = false;
          this.$refs.sortToggle.focus();
        }
      },
      init() {
        this.isMdBreakpoint = this.mdBreakpointMQL.matches;

        this.mdBreakpointMQL.addEventListener('change', (e) => {
          this.isMdBreakpoint = e.matches;
        });

        this.$root.addEventListener('baseline:filterable:open-filters', () => {
          this.filtersOpen = true;
        });

        window.addEventListener('popstate', this.onHistoryChange.bind(this));

        this.$watch('sortOpen', (value) => {
          if (value === true && this.filtersOpen === true) {
            this.filtersOpen = false;
          }
        });

        this.$watch('filtersOpen', (value) => {
          if (value === true && this.sortOpen === true) {
            this.sortOpen = false;
          }
        });
        this.searchParams = new URLSearchParams(window.location.search);
        this.$watch('searchParams', this.onSearchParamsUpdate.bind(this));
        const _that = this;
        const hasChild = {};
        this.firstLevelTags.forEach(function (item) {
          hasChild[item] =
            _that.secondLevelTags.filter(function (tag) {
              return tag.startsWith(item);
            }).length > 0;
        });
        this.secondLevelTags.forEach(function (item) {
          hasChild[item] =
            _that.thirdLevelTags.filter(function (tag) {
              return tag.startsWith(item);
            }).length > 0;
        });
        this.tagHasChild = hasChild;
        this.initTagSuggestions();
        this.initTitleBreadcrumbs();
      },
      async onSearchParamsUpdate(value, oldValue) {
        if (value === oldValue) return;

        // this.beforeUpdate();

        /**
         * [...value] turns searchParams into an array
         * so we can add the section_id in place without
         * modifying the searchParams prop.
         *
         * We use an array instead of an object because
         * filters can have multiple values, so the searchParams
         * needs to support duplicate keys with different
         * values.
         */

        const updatedHTML = await fetchHTML(
          currentURLAddingParams([...value, ['section_id', getSectionId(this.$root)]], true)
        );

        if (this.$root.querySelector(`[data-fragment-id="count"]`)) {
          this.countHTML = querySelectorInHTMLString(`[data-fragment-id="count"]`, updatedHTML).innerHTML;
        }

        if (this.$root.querySelector(`[data-fragment-id="drawer-toggle"]`)) {
          this.drawerToggleHTML = querySelectorInHTMLString(
            `[data-fragment-id="drawer-toggle"]`,
            updatedHTML
          ).innerHTML;
        }

        const filterFormFragmentIds = [
          'filters-form-sidebar-left',
          'filters-form-sidebar-right',
          'filters-form-filters-drop-down',
          'filters-form-sort-drop-down',
          'filters-form-drawer',
          'filters-form-sort-drawer',
          'sort-sidebar-drawer',
        ];

        for (const fragmentId of filterFormFragmentIds) {
          let fragmentEl, updatedFormFragmentEl;
          if (fragmentId === 'filters-form-drawer' || fragmentId === 'filters-form-sort-drawer') {
            fragmentEl = document.getElementById(fragmentId);

            if (!fragmentEl) continue;

            updatedFormFragmentEl = querySelectorInHTMLString(
              `[data-template-fragment-id="${fragmentId}"]`,
              updatedHTML
            ).content.firstElementChild.querySelector(`[data-fragment-id="${fragmentId}"]`);

            if (!updatedFormFragmentEl) continue;
          } else {
            fragmentEl = this.$root.querySelector(`[data-fragment-id="${fragmentId}"]`);

            if (!fragmentEl) continue;

            updatedFormFragmentEl =
              querySelectorInHTMLString(`[data-fragment-id="${fragmentId}"]`, updatedHTML) || null;

            if (!updatedFormFragmentEl) continue;
          }

          fragmentEl.querySelectorAll('[data-filterable-filter-fragment]').forEach((filterableFragmentEl) => {
            const updatedFragment = updatedFormFragmentEl.querySelector(
              `[data-filterable-filter-fragment="${filterableFragmentEl.getAttribute(
                'data-filterable-filter-fragment'
              )}"`
            ).innerHTML;

            if (updatedFragment) filterableFragmentEl.innerHTML = updatedFragment;
          });
        }

        this.resultsHTML = querySelectorInHTMLString(`[data-fragment-id="results"]`, updatedHTML).innerHTML;

        this.afterUpdate();
      },
      // beforeUpdate() {},
      afterUpdate() {
        if (this.focusedBeforeUpdate && document.getElementById(this.focusedBeforeUpdate)) {
          const target = document.getElementById(this.focusedBeforeUpdate);

          this.$focus.focus(target);

          if (target.tagName === 'INPUT' && target.type === 'text') {
            target.select();
          }
          this.focusedBeforeUpdate = null;
        }

        if (!this.historyChanged) {
          this.updateURLHash(this.searchParams);
        } else {
          this.historyChanged = false;
        }

        this.loading = false;

        if (this.afterUpdateCallback) {
          this.$nextTick(() => {
            this.afterUpdateCallback();
            this.afterUpdateCallback = null;
          });
        }
      },
      filterFormSubmit(event) {
        const form = event.target.closest('form');

        if (this.loading || !form) return;
        this.loading = true;

        if (document.activeElement && this.$root.contains(document.activeElement)) {
          const targetId = document.activeElement.getAttribute('id');

          if (targetId) {
            this.focusedBeforeUpdate = targetId;
          }
        }

        const formData = new FormData(event.target.closest('form'));

        for (var [key, value] of this.searchParams.entries()) {
          if (key == 'sort_by') {
            formData.append(key, value);
          }
        }
        this.searchParams = new URLSearchParams(formData);

        if (event.target.name && event.target.name == 'sort_by') {
          this.afterUpdateCallback = () => {
            this.sortOpen = false;
          };
        }
      },
      sortFormSubmit(event) {
        const form = event.target.closest('form');

        if (this.loading || !form) return;
        this.loading = true;

        if (document.activeElement && this.$root.contains(document.activeElement)) {
          const targetId = document.activeElement.getAttribute('id');

          if (targetId) {
            this.focusedBeforeUpdate = targetId;
          }
        }
        const formData = new FormData(event.target.closest('form'));
        var currentData = new FormData();
        if (this.searchParams) {
          for (var [key, value] of this.searchParams.entries()) {
            if (key != 'sort_by') {
              currentData.append(key, value);
            }
          }
        }
        for (var [key, value] of formData.entries()) {
          currentData.append(key, value);
        }
        this.searchParams = new URLSearchParams(currentData);
      },
      clearAllFilters() {
        this.searchParams = new URL(this.$event.currentTarget.href).searchParams;
      },
      initTagSuggestions() {
        var tagLevel = this.activeTags.length;
        var targetSelections = [];
        this.tagLevel = tagLevel;
        var filterStartWith = '';
        switch (tagLevel) {
          case 0: {
            targetSelections = this.firstLevelTags;
            break;
          }
          case 1: {
            targetSelections = this.secondLevelTags;
            filterStartWith = this.activeTags[0] + '_';
            break;
          }
          case 2: {
            targetSelections = this.thirdLevelTags;
            filterStartWith = this.activeTags[1] + '_';
            break;
          }
          case 3: {
            targetSelections = this.thirdLevelTags;
            filterStartWith = this.activeTags[1] + '_';
            var tagParts = this.activeTags[2].split('_');
            this.activeSuggestTag = tagParts[tagParts.length - 1];
            break;
          }
        }

        var suggestions = targetSelections.filter(function (tag) {
          return tag.startsWith(filterStartWith);
        });
        if (filterStartWith != '') {
          // trim the filterStartWith
          suggestions = suggestions.map(function (tag) {
            return tag.substring(filterStartWith.length);
          });
        }
        this.tagSuggestions = suggestions;
      },
      initTitleBreadcrumbs() {
        if (this.activeTags == 0) {
          return;
        }
        var results = [];
        this.activeTags.forEach(function (item) {
          var tagParts = item.split('_');
          results.push(tagParts[tagParts.length - 1]);
        });
        this.activeCategoryTags = results;
      },
      updateURLHash(searchParams) {
        const searchParamsString = searchParams.toString();

        history.pushState(
          { searchParamsString },
          '',
          `${window.location.pathname}${searchParamsString && '?'.concat(searchParamsString)}`
        );
      },
      onHistoryChange(event) {
        this.historyChanged = true;

        this.searchParams = event.state.searchParams || '';
      },
    })
  );

  Alpine.data(
    'Collection_DesignerMenu',
    ({
      menus = [],
    }) => ({
      menus,
      designer_menus: [],
      active_menu: {},
      menu_options: [],
      loading: false,
      searchString: null,
      init(){
        const activeProductType = Alpine.store('global').productType;
        // filter all menus without produc_type
        // set active_menu with menu.product_type == activeProductType
        const that = this;
        this.$watch('active_menu', function(menu){
          that.menu_options = menu.designers;
          that.searchString = null;
        });

        this.$watch('searchString', function(searchString){
          if(searchString){
            const search = new RegExp(searchString, 'i');
            that.menu_options = that.menu_options.filter(option => search.test(option.name));
          }else{
            that.menu_options = that.active_menu.designers;
          }
        });

        const validMenus = this.menus.filter(menu => menu.product_type);
        this.designer_menus = validMenus;
        this.active_menu = validMenus.find(menu => menu.product_type == activeProductType) ?? {};

      },
      onMenuChange(menu){
        if(this.loading) return;
        // set active_menu
        this.active_menu = menu;
      },
      async onLoadAllDesigners(){
        // check active_menu is not null and active_menu has collection_url
        // fetch all designers
        // update active_menu
        // update designer_menus
        if(this.active_menu && this.active_menu.collection_url){
          this.loading = true;
          try{
            const designers = await this.fetchCollectionDesignersJson(this.active_menu.collection_url);
            this.active_menu.designers = designers;
            this.active_menu['loaded_all'] = true;
            this.designer_menus = this.designer_menus.map(menu => {
              if(menu.product_type == this.active_menu.product_type){
                return this.active_menu;
              }
              return menu;
            });
          }finally{
            this.loading = false
          }
        }


      },
      async fetchCollectionDesignersJson(url) {
        const fetchUrl = `${url}?view=designer-list`;
        const response = await fetch(fetchUrl);
        const json = await response.json();
        return json;
      }
    })
  );
});
